const  data = {
  "Bono": {
    "BEREKUM": {
      "BEREKUM": true
    },
    "Sunyani": {
      "Sunyani": true
    }
  },
  "Eastern": {
    "Somanya": {
      "Somanya": true
    },
    "Nsawam": {
      "Nsawam": true
    },
    "Akim Oda": {
      "Akim Oda": true
    },
    "New Abirem": {
      "New Abirem": true
    },
    "Nkawkaw": {
      "Nkawkaw": true
    },
    "Akosombo": {
      "Akosombo": true
    },
    "Suhum": {
      "Suhum": true
    },
    "Koforidua": {
      "Zongo": true,
      "Water works": true,
      "Two Streams": true,
      "Trom": true,
      "Tei Nkwanta": true,
      "Tafo": true,
      "Suhyen": true,
      "St.James": true,
      "St James": true,
      "SSNIT": true,
      "Srodae": true,
      "Rasta down": true,
      "Pipeline": true,
      "Oyoko": true,
      "Osabene": true,
      "Opoku Nsiah": true,
      "Old Estate": true,
      "Okorase": true,
      "Oguaa": true,
      "Nyamekrom": true,
      "Nurse": true,
      "Nsukwao": true,
      "Nkurakan": true,
      "Monrovia": true,
      "Monroua": true,
      "Mile 50": true,
      "Magazine": true,
      "Lowcost": true,
      "Liberty": true,
      "Kurakan": true,
      "Kukurantumi": true,
      "KTU": true,
      "Korley Nkwanta": true,
      "Korley Newtown": true,
      "Korley": true,
      "Korle Nkra": true,
      "Koforidua": true,
      "Kofikrom": true,
      "Kentenkren": true,
      "Kentekre": true,
      "Kasadjan": true,
      "Kantudu": true,
      "K. Poly": true,
      "Jumapo": true,
      "Highways": true,
      "Galaway": true,
      "Effiduase": true,
      "Effichale": true,
      "Dalriasem": true,
      "Dabi asem": true,
      "Daasebre Estates": true,
      "Charlie Junction": true,
      "Bohye": true,
      "Betom": true,
      "Barrier": true,
      "Baakokrom": true,
      "Atekyem": true,
      "Asorko": true,
      "Asokore Kuma": true,
      "Asokore": true,
      "Apenkwa": true,
      "Antotown": true,
      "Anlo Town": true,
      "All Nations New Site": true,
      "Akwadum": true,
      "Agavenya": true,
      "Adweso": true,
      "Ada": true,
      "Abrewa Nkwanta": true,
      "Abogri": true,
      "Aboado": true,
      "Aboabo": true
    }
  },
  "Ashanti": {
    "Kumasi": {
      "Sofoline Market": true,
      "Zongo": true,
      "Woamoase": true,
      "Tanoso": true,
      "Tafo": true,
      "Suame": true,
      "South Suntreso": true,
      "Sokoban": true,
      "Sofoline": true,
      "Sepe Timpom": true,
      "Sepe dote": true,
      "Sepe Brokrom": true,
      "Sawaba": true,
      "Santasi": true,
      "Patasi": true,
      "Parkoso": true,
      "Papaase": true,
      "Pankrono": true,
      "Ohwimase": true,
      "Oforikurom": true,
      "Oduom": true,
      "Odeneho Kwadaso": true,
      "Obuasi": true,
      "Nzema": true,
      "Nsenie": true,
      "North Suntreso": true,
      "Nkronsa": true,
      "New Zongo": true,
      "Moeshie Zongo": true,
      "Medoma": true,
      "Mayanka": true,
      "Maxima": true,
      "Manhyia": true,
      "Mamponteng": true,
      "Maakro": true,
      "Lobito": true,
      "Kwamo": true,
      "Kwadaso": true,
      "Kronum": true,
      "Kromuase": true,
      "Krofrom": true,
      "Krapa": true,
      "Kotwi": true,
      "Kotei": true,
      "Konkromase": true,
      "Knust": true,
      "Kenyase": true,
      "Kentikrono": true,
      "Kejetia": true,
      "Karmo": true,
      "Kaase": true,
      "IPT": true,
      "Gyenyasi": true,
      "Fanti New Town": true,
      "Fankyenebra": true,
      "Ejisu": true,
      "Edwenase": true,
      "Dichemso": true,
      "Deduako": true,
      "Danyame": true,
      "Dakodwon": true,
      "Daban": true,
      "Buokurom": true,
      "Buokrom Estate": true,
      "Buoho": true,
      "Brofoyedu": true,
      "Bremang": true,
      "Bomso": true,
      "Bohyen": true,
      "Block 8": true,
      "Bimpeh Hill": true,
      "Bantama": true,
      "Ayigya": true,
      "Ayeduase": true,
      "Atonsu": true,
      "Atimatim": true,
      "Atasomanso": true,
      "Asuoyeboa": true,
      "Asuofua": true,
      "Asokwa": true,
      "Asokore Mampong": true,
      "Ashtown": true,
      "Asenua": true,
      "Asebi": true,
      "Asawasi": true,
      "Asafo": true,
      "Apraman": true,
      "Aprade": true,
      "Appiadu": true,
      "Apere": true,
      "Apemso": true,
      "Anyinam": true,
      "Anwomaso": true,
      "Anloga": true,
      "Ampabame": true,
      "Amanfrom": true,
      "Amakom": true,
      "Akwatialine": true,
      "Ahwiaa": true,
      "Ahodwo": true,
      "Ahenmma Kokobeng": true,
      "Agric": true,
      "Afrancho": true,
      "Adum": true,
      "Adukrom": true,
      "Adoato": true,
      "Adiemmra": true,
      "Adiebeba": true,
      "Adehyeman": true,
      "Adako Jachie": true,
      "Achiase": true,
      "Abuakwa": true,
      "Abrepo": true,
      "Aboabo": true,
      "Aberem": true,
      "Abease": true
    },
    "Asante Mampong": {
      "Asante Mampong": true
    },
    "Obuasi": {
      "Obuasi": true
    },
    "Konongo": {
      "Konongo": true
    },
    "Asante Agona": {
      "Asante Agona": true
    },
    "Offinso": {
      "Offinso": true
    },
    "Agogo": {
      "Agogo": true
    }
  },
  "Greater Accra": {
    "Accra": {
      "Dome Kwabenya": true,
      "Ridge": true,
      "Winconsin Int.": true,
      "Westhills": true,
      "West Ridge": true,
      "West Legon": true,
      "West land": true,
      "Weija": true,
      "VIP Station": true,
      "Victoriaborg": true,
      "Ussher Town": true,
      "UPSA": true,
      "UG-Legon": true,
      "Tunga": true,
      "Tudu": true,
      "Tuba": true,
      "Trassacco": true,
      "Teshie": true,
      "Teshi": true,
      "Tesano": true,
      "Sun City": true,
      "Sowutoum": true,
      "South Industrial Area": true,
      "Shiashie": true,
      "Santeo": true,
      "Sabon Zongo": true,
      "Roman Ridge": true,
      "Ritz Junction": true,
      "Ring Road": true,
      "Rawlings Park": true,
      "Pokuase": true,
      "Pleasant Hill": true,
      "Parakuo Estates": true,
      "Pantang": true,
      "Oyibi": true,
      "Oyarifa": true,
      "Osu-re": true,
      "Osu Oxford Street": true,
      "Osu Ako-adjei": true,
      "Osu": true,
      "Opeikuma": true,
      "Old barrier": true,
      "Old Ashongman": true,
      "Okpoi Gonno": true,
      "Ogbodjo": true,
      "Ofankor": true,
      "Ofaakor": true,
      "Odorkor": true,
      "Nyanyano kakraba": true,
      "Nyanyano": true,
      "Nungua Central": true,
      "Norwood City": true,
      "North Ridge": true,
      "North Legon": true,
      "North Kaneshie": true,
      "North Industrial Area": true,
      "North Dzorwulu": true,
      "Nmai Djor": true,
      "Nima": true,
      "Nii Okaiman East": true,
      "Nii Okaiman": true,
      "New market": true,
      "New Legon": true,
      "Nana Krom": true,
      "Mpoase": true,
      "Ministries": true,
      "Millennium city": true,
      "Mile 11": true,
      "McCarthy Hill": true,
      "Mataheko": true,
      "Manet courts": true,
      "Mamprobi": true,
      "Mallam": true,
      "Makola": true,
      "Madina": true,
      "Maamobi": true,
      "Lybia Quarters": true,
      "Liberia camp": true,
      "Legon": true,
      "Lartebiokorshie": true,
      "Lapaz": true,
      "Lamprey mills": true,
      "Lakeside Estate": true,
      "Labone": true,
      "Labadi": true,
      "Kwashieman": true,
      "Kwabenya.": true,
      "Kuku Hill": true,
      "Krispol city": true,
      "Kotobabi": true,
      "Korle Gonno": true,
      "Korle Bu": true,
      "Kokrobite": true,
      "Kokomlemle": true,
      "Kissieman": true,
      "Kinbu": true,
      "Kasoa C. P": true,
      "Kasoa": true,
      "Kantamanto": true,
      "Kaneshie Maket": true,
      "Kaneshie": true,
      "Kanda": true,
      "Kaff university": true,
      "John Teye": true,
      "Janman": true,
      "James Town": true,
      "Housing down": true,
      "High Street": true,
      "Haatso": true,
      "Gold Coast City": true,
      "GIMPA": true,
      "Gbawe": true,
      "Frafraha": true,
      "Ecomog": true,
      "East Legon Hills": true,
      "East Legon": true,
      "Dzorwulu": true,
      "Domeabra.": true,
      "Dome": true,
      "Dodowa": true,
      "Darkuman": true,
      "Dansoman": true,
      "Danfa": true,
      "Commandos": true,
      "Circle": true,
      "Christian Village": true,
      "Christian Borg": true,
      "Chorkor": true,
      "Cfc Estates, Taifa": true,
      "Cantonments": true,
      "Burma Hills": true,
      "Burma Camp": true,
      "Burkie": true,
      "Bukom": true,
      "Bubiashie": true,
      "Broadcasting": true,
      "Awoshie": true,
      "Asylum Down": true,
      "Ashongman Estates": true,
      "Ashongman": true,
      "Ashiyie": true,
      "Ashiedu Keteke": true,
      "Ashaley Botwe": true,
      "Amasaman": true,
      "Amanhia": true,
      "Amanfrom": true,
      "Alajo": true,
      "Akweteyman": true,
      "Akweley": true,
      "Airport West": true,
      "Airport Residential Area": true,
      "Airport Hills": true,
      "Airport City": true,
      "Agbogba Junction": true,
      "Agbogba": true,
      "Adjiringanor": true,
      "Adenta West": true,
      "Adenta Village": true,
      "Adenta Municipality": true,
      "Adenta": true,
      "Adam nana": true,
      "Adade": true,
      "Adabraka": true,
      "Achimota": true,
      "Achiaman": true,
      "Accra New Town": true,
      "Abosseyokai": true,
      "Abokobi": true,
      "Ablekuma Fan-Milk": true,
      "Ablekuma": true,
      "Abelemkpe": true,
      "Abeka": true
    },
    "Tema": {
      "Kpone Tema": true,
      "Zeetech Light Industrial Area": true,
      "Valco Park": true,
      "Valco Estates": true,
      "V.R.A Estates": true,
      "Tsinai-agbe": true,
      "Tema New Town": true,
      "Prampram": true,
      "Podoku": true,
      "Neighbourhood 3": true,
      "Mlichakpo": true,
      "Kwambla Gon": true,
      "Kpone": true,
      "Kortu-gon": true,
      "Heavy Industrial Area": true,
      "Golf City": true,
      "Dawhenya": true,
      "Community Two": true,
      "Community Twelve": true,
      "Community Three": true,
      "Community Ten": true,
      "Community Six": true,
      "Community Seven": true,
      "Community One": true,
      "Community Nine": true,
      "Community Four": true,
      "Community Five": true,
      "Community Eleven": true,
      "Community Eight": true,
      "Community 25": true,
      "Community 23": true,
      "Community 22": true,
      "Community 21": true,
      "CMB Village": true,
      "Central University": true,
      "Akorley-dzor": true
    },
    "Ashaiman": {
      "Zenu": true,
      "Sraha": true,
      "Sebrepor": true,
      "New York": true,
      "Lebanon": true,
      "Klagon": true,
      "Katamanso": true,
      "Attah Dika": true,
      "Ashaiman": true,
      "Afariwa": true,
      "Adjei kojo": true
    },
    "Spintex": {
      "Sakumono ESTATE": true,
      "Sakumono": true,
      "Reg Gray Est": true,
      "Lashibi": true,
      "Community Twenty": true,
      "Community Nineteen": true,
      "Community Eighteen": true,
      "Community 17": true,
      "Borteyman": true,
      "Baatsonaa": true
    }
  },
  "Volta": {
    "Ho": {
      "Ho Town": true,
      "Zongo": true,
      "UHAS New Site": true,
      "Trafalgar": true,
      "Total": true,
      "SSNIT Flats": true,
      "Redeem": true,
      "PWD": true,
      "Power House": true,
      "Ola": true,
      "Muwuli School Area": true,
      "Mirage": true,
      "Medical Village": true,
      "Mawuli Estate": true,
      "Lokoe": true,
      "Ho Poly": true,
      "Ho Market Area": true,
      "Ho": true,
      "Guinness": true,
      "Godokpe": true,
      "Dome": true,
      "Deme": true,
      "Dave": true,
      "Dabra": true,
      "CK Road": true,
      "Civic Center": true,
      "Bentotal": true,
      "Barracks New Town": true,
      "Bankoe": true,
      "Area 52": true,
      "Alaye": true,
      "Akpenamawu": true,
      "Ahoe": true
    },
    "Aflao": {
      "Aflao": true
    },
    "Hohoe": {
      "Hohoe": true
    },
    "Keta": {
      "Keta": true
    },
    "Sogakope": {
      "Sogakope": true
    },
    "Akatsi": {
      "Akatsi": true
    }
  },
  "Central": {
    "Mankessim": {
      "Mankessim Town": true,
      "Mankessim": true
    },
    "Assin Fosu": {
      "Assin Fosu": true
    },
    "Dunkwa on-Offin": {
      "Dunkwa on-Offin": true
    },
    "Winneba": {
      "Winneba": true
    },
    "Agona Swedru": {
      "Agona Swedru": true
    },
    "Cape Coast": {
      "Ucc old site": true,
      "Ucc new site": true,
      "third Ridge": true,
      "Tantri": true,
      "Swidu": true,
      "Second Ridge": true,
      "Post Office": true,
      "Pedu": true,
      "Ola": true,
      "Nyamoransa": true,
      "Nkanfoa": true,
      "Mpeasem": true,
      "Moree": true,
      "Mfanstipim": true,
      "Kwaprow": true,
      "Kwapro": true,
      "Kotokoraba": true,
      "Komenda": true,
      "Kingsway": true,
      "Kakumdo": true,
      "Green Hill": true,
      "First Ridge": true,
      "Eyifua": true,
      "Esuekyir": true,
      "Elmina": true,
      "Ekon": true,
      "Eguase": true,
      "Duakuro": true,
      "C-poly": true,
      "Cape Coast": true,
      "Brafoyaw": true,
      "Bakano": true,
      "Ayensudo": true,
      "Ayensu": true,
      "Ankaful": true,
      "Amamoa": true,
      "Akyim": true,
      "Akotokyire": true,
      "Adisadel": true,
      "Abura": true,
      "Abra": true
    }
  },
  "Bono East": {
    "Techiman": {
      "Techiman": true
    }
  },
  "Ahafo": {
    "Ahafo Kenyasi": {
      "Ahafo Kenyasi": true
    }
  },
  "Western": {
    "Asankragua": {
      "Asankragua": true
    },
    "Tarkwa": {
      "Tarkwa": true
    },
    "Takoradi": {
      "Whindo": true,
      "Tanakrom": true,
      "Takoradi": true,
      "Secondi": true,
      "Pipe Ano": true,
      "Ntankoful": true,
      "Nkroful": true,
      "Ngyiresia": true,
      "New Takoradi": true,
      "New Amanful": true,
      "Mpintsin": true,
      "Mpatado": true,
      "Market Circle": true,
      "Mapees": true,
      "Kwesimintsim": true,
      "Kweikuma": true,
      "Kojokrom": true,
      "Keteen": true,
      "Kegedir": true,
      "Kasawurdo": true,
      "Inehaban": true,
      "Fijai": true,
      "Essipon": true,
      "Essikado": true,
      "Essia": true,
      "Effiakuma": true,
      "Effia Nkwanta": true,
      "Chapel Hill": true,
      "Bronyikrom": true,
      "Beach Road": true,
      "Bankyiase": true,
      "Assakae": true,
      "Apremdo": true,
      "Apowa": true,
      "Apolo": true,
      "Anaji": true,
      "Airport Ridge": true,
      "Airforce BU": true,
      "Adientsem": true,
      "Adientan": true,
      "Adiembra": true,
      "Abutumagyebu": true,
      "Aboadze": true
    },
    "Takoradi Airport": {
      "Tanokrom": true,
      "Tano Krom": true,
      "T Poly": true,
      "Shama": true,
      "Sekondi": true,
      "Race course": true,
      "Pipe Ano": true,
      "Nkroful Junction": true,
      "Nkotonpo": true,
      "Nkontompo": true,
      "New Tardi": true,
      "New Amanful": true,
      "Mpintsin": true,
      "Market Circle": true,
      "Lagos Town": true,
      "Kwesimintsim": true,
      "Kwesimintim": true,
      "Kweikuma": true,
      "Ketan": true,
      "Kejabil": true,
      "Kansaworodo": true,
      "Funko": true,
      "Fijai": true,
      "Ewusiejo": true,
      "Essipong": true,
      "Essikado": true,
      "Essaman": true,
      "Esaaman": true,
      "Ekuase": true,
      "Egyam": true,
      "Effiakuma": true,
      "Effia Nkwanta Hospital": true,
      "Effia nkwanta": true,
      "Effia": true,
      "Diabene": true,
      "BU": true,
      "Bokoro": true,
      "Beahu": true,
      "Beach Road": true,
      "Baka-Ekyir": true,
      "Bakaekyir": true,
      "Apremdo": true,
      "Apowaa": true,
      "Anaji": true,
      "Airport Ridge": true,
      "Agona": true,
      "Adiembra": true,
      "Abuesi": true,
      "Aboadze": true
    }
  },
  "Upper East": {
    "Bawku": {
      "Bawku": true
    },
    "Navrongo": {
      "Navrongo": true
    },
    "Bolgatanga": {
      "Bolgatanga": true
    }
  },
  "Upper West": {
    "Wa": {
      "Wa": true
    }
  },
  "Brong Ahafo": {
    "Techiman": {
      "Techiman": true
    },
    "Sunyani": {
      "Sunyani": true
    }
  },
  "Northern": {
    "Tamale": {
      "Tamale": true,
      "Sakasak": true,
      "Nyanshegu": true,
      "Moshie Zongo": true,
      "Lamashigu": true,
      "Kalpohin Estates": true,
      "Kaakpayilli": true,
      "Jekeriyili": true,
      "Checko": true
    }
  }
};


(function () {
  function findTrimmedKey(obj, wanted) {
    const w = String(wanted ?? '').trim();
    return Object.keys(obj || {}).find(k => String(k).trim() === w) || null;
  }

  function transformInputToSelect(inputElement, placeholder) {
    if (!inputElement) return null;

    if (inputElement.tagName === "SELECT") {
      if (!inputElement.querySelector("option[value='']")) {
        const placeholderOption = document.createElement("option");
        placeholderOption.value = "";
        placeholderOption.className = "rsi-select-placeholder";
        placeholderOption.textContent = placeholder || "Seleccione";
        inputElement.insertBefore(placeholderOption, inputElement.firstChild);
      }
      inputElement.classList.add("rsi-select-field");
      return inputElement;
    }

    const select = document.createElement("select");

    select.id = inputElement.id || "";
    select.name = inputElement.name || "";

    select.className = "sc-gSifMm jtIFEn rsi-select-field";

    select.style.cssText = `
      width: 100%;
      height: 32px;
      padding: 0px 25px;
      border: none;
      font-size: 16px;
      color: rgb(0, 0, 0);
      background-color: rgba(169, 181, 211, 0.09);
      box-shadow: none;
      outline: none;
      background-image: url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E);
      background-repeat: no-repeat;
      background-position: right 0.7em top 50%;
      background-size: 0.65em;
      appearance: none;
      margin: 0px !important;
      border-radius: 0px 9px 9px 0px !important;
    `;

    ["autocomplete", "required", "data-maxl", "data-minl"].forEach(attr => {
      if (inputElement.hasAttribute(attr)) {
        select.setAttribute(attr, inputElement.getAttribute(attr));
      }
    });

    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.className = "rsi-select-placeholder";
    placeholderOption.textContent = placeholder || "Seleccione";
    select.appendChild(placeholderOption);

    inputElement.replaceWith(select);

    return select;
  }

  function populateDropdown(selectElement, options, placeholder) {
    if (!selectElement) return;

    function normalizeOptions(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) {
        if (!raw.length) return [];
        if (typeof raw[0] === "object") {
          return raw.map(o => {
            const v = o?.value != null ? String(o.value) : String(o?.label ?? "");
            const l = o?.label != null ? String(o.label) : v;
            return { value: v, label: l.trim() };
          });
        }
        return raw.map(s => {
          const txt = String(s);
          return { value: txt, label: txt.trim() };
        });
      }
      if (typeof raw === "object") {
        return Object.keys(raw).map(k => {
          const v = String(k);
          return { value: v, label: v.trim() };
        });
      }
      const asTxt = String(raw);
      return [{ value: asTxt, label: asTxt.trim() }];
    }

    selectElement.innerHTML = "";
    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.className = "rsi-select-placeholder";
    placeholderOption.textContent = placeholder || "";
    selectElement.appendChild(placeholderOption);

    let list = [];
    try {
      list = normalizeOptions(options);
    } catch (e) {
      console.error("[populateDropdown] error normalizando opciones:", e, options);
      list = [];
    }

    for (const item of list) {
      if (!item || item.value == null) continue;
      const option = document.createElement("option");
      option.value = String(item.value);                   
      option.textContent = String(item.label ?? item.value).trim(); 
      option.className = "rsi-select-option";
      selectElement.appendChild(option);
    }

    if (list.length === 1) {
      selectElement.value = list[0].value;
      selectElement.dispatchEvent(new Event("change"));
    }
  }

  function initializeDropdowns() {
    const provinceInput     = document.querySelector("#province_country_field, #province");
    const cityInput         = document.querySelector("#city");
    const municipalityInput = document.querySelector("#civic_number");

    if (!provinceInput || !cityInput || !municipalityInput) {
      console.error("Faltan campos requeridos:", {
        province: !!provinceInput, city: !!cityInput, civic: !!municipalityInput
      });
      return;
    }

    const provinceSelect     = transformInputToSelect(provinceInput, "Provincia");
    const citySelect         = transformInputToSelect(cityInput, "Cantón");
    const municipalitySelect = transformInputToSelect(municipalityInput, "Distrito");

    citySelect.disabled = true;
    municipalitySelect.disabled = true;

    populateDropdown(provinceSelect, (typeof data === "object") ? data : {}, "Provincia");

    provinceSelect.addEventListener("change", function () {
      const selProv = provinceSelect.value;
      const provKey = findTrimmedKey(data, selProv);

      if (provKey && data[provKey]) {
        populateDropdown(citySelect, data[provKey], "Cantón");
        citySelect.disabled = false;

        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Distrito</option>';
        municipalitySelect.disabled = true;

        const cityKeys = Object.keys(data[provKey] || {});
        if (cityKeys.length === 1) {
          citySelect.value = cityKeys[0];
          citySelect.dispatchEvent(new Event("change"));
        }
      } else {
        citySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Cantón</option>';
        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Distrito</option>';
        citySelect.disabled = true;
        municipalitySelect.disabled = true;
      }
    });

    citySelect.addEventListener("change", function () {
      const selProv = provinceSelect.value;
      const selCity = citySelect.value;

      const provKey = findTrimmedKey(data, selProv);
      const cityKey = provKey ? findTrimmedKey(data[provKey], selCity) : null;

      if (provKey && cityKey && data[provKey][cityKey]) {
        populateDropdown(
          municipalitySelect,
          data[provKey][cityKey],   
          "Distrito"
        );
        municipalitySelect.disabled = false;

        const muniKeys = Object.keys(data[provKey][cityKey] || {});
        if (muniKeys.length === 1) {
          municipalitySelect.value = muniKeys[0];
          municipalitySelect.dispatchEvent(new Event("change"));
        }
      } else {
        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Distrito</option>';
        municipalitySelect.disabled = true;
      }
    });
  }

  const PROV_SELECTOR = "#province_country_field, #province";
  let formWasOpen = false;

  function tryInit() {
    const provinceField = document.querySelector(PROV_SELECTOR);
    if (provinceField && !formWasOpen) {
      formWasOpen = true;
      initializeDropdowns();
    }
    if (!provinceField && formWasOpen) {
      formWasOpen = false;
    }
  }

  tryInit();
  document.addEventListener("DOMContentLoaded", tryInit);
  const observer = new MutationObserver(tryInit);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
